// src/config/api.ts
const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080"
)
  .trim()
  .replace(/\n/g, ""); // 줄바꿈 및 공백 제거

// 디버깅: 실제 사용되는 API URL 확인
if (typeof window !== "undefined") {
  console.log("🔍 API Configuration Debug:", {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    VERCEL_ENV: process.env.VERCEL_ENV,
    Actual_API_BASE_URL: API_BASE_URL,
    Hostname: window.location.hostname,
  });
}

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/admin/login`,
  },
  PRODUCTS: `${API_BASE_URL}/api/products`,
  PRESIGNED_URL: {
    THUMBNAIL: `${API_BASE_URL}/api/products/presigned-url`, // 썸네일 이미지용
    COURSE_CONTENT: (productId: string) =>
      `${API_BASE_URL}/api/product-contents/products/${productId}/presigned-url`, // 강좌 컨텐츠용
  },
  PRODUCT_CONTENTS: {
    CREATE: (productId: string) =>
      `${API_BASE_URL}/api/product-contents/products/${productId}`, // 컨텐츠 등록
    LIST: (productId: string) =>
      `${API_BASE_URL}/api/product-contents/products/${productId}`, // 컨텐츠 목록 조회
    DELETE: (contentId: string) =>
      `${API_BASE_URL}/api/product-contents/${contentId}`, // 컨텐츠 삭제
  },
  STUDENT_RECORDS: `${API_BASE_URL}/api/student-records`, // 학생부 파일 목록 조회
  INTERVIEW: {
    ANALYZE: `${API_BASE_URL}/api/program/interview/analyze`, // 면접 분석 요청
    GET_RESULT: (studentRecordId: string) =>
      `${API_BASE_URL}/api/program/interview/result/${studentRecordId}`, // 분석 결과 조회
    STATUS_STREAM: (sessionId: string) =>
      `${API_BASE_URL}/api/program/interview/status/${sessionId}/stream`, // SSE 스트림 연결
  },
};

export default API_BASE_URL;
